//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { crl8 } from 'app/curalate.globals';

export function hasPermissionForTask(task: string): boolean {
  return !!crl8.session.permissions[task];
}

export function hasPermissionForAnyTask(tasks: string[]): boolean {
  return tasks.some(hasPermissionForTask);
}

export function hasPermissionForAllTasks(tasks: string[]): boolean {
  return tasks.every(hasPermissionForTask);
}
